import "./CommunitiesWeServe.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CityDirectory from "./sections/CityDirectory";
import SocialProof from "./sections/SocialProof";
import CtaFooter from "./sections/CtaFooter";
import Footer from "@/reusable_sections/Footer";
export default function CommunitiesWeServePage() {
  return <div>
      <Header />
      <Hero />
      <CityDirectory />
      <SocialProof />
      <CtaFooter />
      <Footer />
    </div>;
}